<template>
  <m-category-wrapper :single-category="singleCategory">
    <template v-slot="{categories}">
      <swiper id="categories307-categories-slider" class="mySwiper w-100 px-5"
              v-bind="swiperOptions" :navigation="true" :modules="modules">

        <template v-for="category in flatCategories(categories)" :key="category.id">
          <swiper-slide v-if="category.products_count > 0" class=" ">

            <m-a v-if="linkStatus" :href="setLinkType(category,linkType)">
              <component @click="selectCategory(category)" :category="category" :is="categoryCard"/>
            </m-a>
            <component @click="selectCategory(category)" :category="category" :is="categoryCard" v-else/>


          </swiper-slide>
        </template>


      </swiper>
    </template>
  </m-category-wrapper>
</template>

<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import {EffectFade} from 'swiper';
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import {Navigation} from "swiper";
import mCategoryWrapper from "../../Wrappers/CategoryWrapper";
import {flatCategories,} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category'
import mCategoryCard310 from "../Card/CategoryCard310.vue";
import mA from '../../Tags/A.vue'
import {categoryMethods} from "../CategoriesMethods";
import {Cards} from '../Card/Cards'

export default {
  name: "Categories308",
  components: {Swiper, SwiperSlide, mCategoryWrapper, mA, ...Cards},
  props: {
    singleCategory: {
      default: null
    },
    linkStatus: {
      type: Boolean,
      default: false,
    },
    linkType: {
      default: 'SingleCategory',
    },
    categoryCard: {
      options: Object.keys(Cards),
      default: 'mCategoryCard1'
    },
    swiperPerViewSM: {
      type: Number,
      default: 2,
    },
    swiperPerViewMD: {
      type: Number,
      default: 4,
    },
    swiperPerViewLG: {
      type: Number,
      default: 6,
    },
  },
  data() {
    return {
      selectedCategory: [],
      swiperOptions: {
        spaceBetween: 15,
        breakpoints: {
          300: {
            slidesPerView: 2,
          },
          400: {
            slidesPerView: 3,
          },
          430: {
            slidesPerView: 3,
          },
          490: {
            slidesPerView: 4,
          },
          520: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 6,
          },
          980: {
            slidesPerView: 6,
          },
          1200: {
            slidesPerView: 6,

          },
        },
      },
    }
  },
  methods: {
    ...categoryMethods,
    selectCategory(category) {
      this.selectedCategory = []
      if (category !== '') {
        this.selectedCategory.push(category.slug)
        this.$emit('category', category)
        return true
      }
      this.selectedCategory = null
      this.$emit('category', category)
    },
    flatCategories,
  },
  setup() {
    return {
      modules: [Navigation, EffectFade],
    };
  },
  beforeMount() {

    this.swiperOptions.breakpoints["300"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["400"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["430"].slidesPerView = this.swiperPerViewSM
    this.swiperOptions.breakpoints["490"].slidesPerView = this.swiperPerViewSM

    this.swiperOptions.breakpoints["520"].slidesPerView = this.swiperPerViewMD
    this.swiperOptions.breakpoints["768"].slidesPerView = this.swiperPerViewMD

    this.swiperOptions.breakpoints["980"].slidesPerView = this.swiperPerViewLG
    this.swiperOptions.breakpoints["1200"].slidesPerView = this.swiperPerViewLG

  }
}
</script>


<style scoped>
</style>